import React, { FC } from 'react';
import { Grid, TextField, Button, FormControl, FormHelperText } from '@mui/material';
import { SubmitHandler, useForm } from 'react-hook-form';
import { yupResolver } from '@hookform/resolvers/yup';
import * as yup from 'yup';
import { WebhookEndpoints } from '@models';
import { useAppSelector } from '@hooks/redux-custom';

const schema = yup.object({
  url: yup.string().required('URL is required'),
  description: yup.string(),
});

type Props = {
  onSave: (formData: WebhookEndpoints) => void;
  title: string;
};

const WebhookForm: FC<Props> = ({ onSave, title }) => {
  const {
    register,
    handleSubmit,
    formState: { errors },
  } = useForm<WebhookEndpoints>({
    resolver: yupResolver(schema),
    defaultValues: {
      url: '',
      description: '',
    },
  });

  const onSubmit: SubmitHandler<WebhookEndpoints> = (formData: WebhookEndpoints) => {
    onSave(formData);
  };

  return (
    <form onSubmit={handleSubmit(onSubmit)}>
      <Grid container alignItems="center" spacing={2}>
        <Grid item xs={5}>
          <FormControl fullWidth>
            <TextField
              {...register('url')}
              fullWidth
              error={!!errors.url}
              helperText={errors.url?.message}
              placeholder={`Enter ${title} url`}
              name="url"
              data-testid="url-text"
            />
            {errors.url && <FormHelperText>{errors.url.message}</FormHelperText>}
          </FormControl>
        </Grid>
        <Grid item xs={5}>
          <FormControl fullWidth>
            <TextField
              {...register('description')}
              fullWidth
              error={!!errors.description}
              helperText={errors.description?.message}
              placeholder="Enter Description..."
              name="description"
              data-testid="webhook-form-description-text"
            />
            {errors.description && <FormHelperText>{errors.description.message}</FormHelperText>}
          </FormControl>
        </Grid>
        <Grid item xs={2}>
          <Button variant="contained" type="submit" data-testid="save-button">
            Add
          </Button>
        </Grid>
      </Grid>
    </form>
  );
};

export default WebhookForm;
